var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
Aedu.UserCard = function (superClass) {
  extend(UserCard, superClass);
  function UserCard() {
    return UserCard.__super__.constructor.apply(this, arguments);
  }
  UserCard.prototype.initialize = function (options) {
    var ref;
    UserCard.__super__.initialize.call(this, {
      html: true,
      placement: 'bottom',
      container: this._card_container(),
      show_delay: 400,
      hide_delay: 250,
      content: function (_this) {
        return function () {
          return _this._card_content();
        };
      }(this),
      template: function () {
        return $($.fn.popover.Constructor.DEFAULTS.template).addClass('popover-hovercard user-card');
      }()
    });
    if (this.$el.data('hide-on-scroll')) {
      this._register_hide_on_any_parent_scroll();
    }
    this.user = options.user || this._find_user_from_content();
    if (this.user != null) {
      this._init_clickable();
      this.on_shown = this._show_stats;
      if (this.user.id !== ((ref = Aedu.User.current) != null ? ref.id : void 0)) {
        return this._handle_message_click();
      }
    }
  };
  UserCard.prototype._find_user_from_content = function () {
    var content, content_el, user_id;
    user_id = this.$el.data('has-card-for-user');
    content_el = $("*[data-card-contents-for-user=" + user_id + "]");
    if (content_el && (content = content_el.html())) {
      return this.user = Aedu.User.from_json(content);
    }
  };
  UserCard.prototype._init_clickable = function () {
    return this.$el.data('bs.popover').tip().on('click', '.user-card-main', function (_this) {
      return function (e) {
        if (!(e.metaKey || e.ctrlKey)) {
          return window.location = _this.user.url;
        }
      };
    }(this));
  };
  UserCard.prototype._register_hide_on_any_parent_scroll = function () {
    var results, scrollParent;
    scrollParent = this.$el.scrollParent();
    results = [];
    while (scrollParent.length > 0) {
      scrollParent.scroll(function (_this) {
        return function () {
          if (_this.popover_shown) {
            return _this._hide();
          }
        };
      }(this));
      if (scrollParent.parent().length > 0) {
        results.push(scrollParent = scrollParent.scrollParent());
      } else {
        results.push(scrollParent = $());
      }
    }
    return results;
  };
  UserCard.prototype._handle_message_click = function () {
    if (!$a.is_logged_in()) {
      return;
    }
    return this.$el.on('shown.bs.popover', function (_this) {
      return function () {
        var message_btn;
        message_btn = _this.$el.data('bs.popover').tip().find('*[data-send-message]');
        if (!message_btn.data('message-view')) {
          message_btn.data('message-view', new Messages.ModalFormView(_this.user.id));
        }
        message_btn.data('message-view').on('shown', function () {
          return _this.freeze();
        });
        return message_btn.data('message-view').on('hidden', function () {
          return _this.unfreeze();
        });
      };
    }(this));
  };
  UserCard.prototype._show_stats = function ($popover) {
    var set_stat;
    set_stat = function (_this) {
      return function (stat, value) {
        var selector;
        selector = "*[data-stats-for-user=" + _this.user.id + "] .user-card-stat-num[data-stat=" + stat + "]";
        return $popover.find(selector).text($h.commaizeInt(value));
      };
    }(this);
    this.user.load_followers_count().done(function (_this) {
      return function (c) {
        return set_stat('followers_count', c);
      };
    }(this));
    this.user.load_works_count().done(function (_this) {
      return function (c) {
        return set_stat('works_count', c);
      };
    }(this));
    return this.user.load_views_counts().done(function (_this) {
      return function (c) {
        return set_stat('views_count', c.all_time_stats.documents_count + c.all_time_stats.non_documents_count);
      };
    }(this));
  };
  UserCard.prototype._card_content = function () {
    return JST['core_post_webpack/sitewide_business_elements/user_card/templates/card']({
      profile: this.user,
      research_interest_sentence: this._research_interest_sentence()
    });
  };
  UserCard.prototype._card_container = function () {
    if (!(this.$el.parent().is("div, li") && this.$el.parents('.bootstrap').length)) {
      return '#bootstrap-modal-container';
    }
  };
  UserCard.prototype._research_interest_sentence = function (top_n) {
    var interest_count, interests_to_show, parts, top_interests;
    if (top_n == null) {
      top_n = 2;
    }
    if (!this.user.has_research_interests()) {
      return;
    }
    interest_count = this.user.interests.length;
    interests_to_show = interest_count > top_n + 1 ? top_n : interest_count;
    top_interests = _(this.user.interests).first(interests_to_show);
    parts = top_interests.map(function (i) {
      return i.name;
    });
    if (interest_count > interests_to_show) {
      parts.push(interest_count - interests_to_show + " more interests");
    }
    return $h.to_sentence(parts);
  };
  return UserCard;
}(HoverPopover);
if ($a.is_logged_in()) {
  $a.each_current_and_future('*[data-has-card-for-user]', function (el) {
    return new Aedu.UserCard({
      el: $(el)
    });
  });
}
window.extend = extend;
window.hasProp = hasProp;